export const TERRITORIES = {
  AUVERGNE: 'FILTERS_TERRITORIES_AUVERGNE',
  BOURGOGNE: 'FILTERS_TERRITORIES_BOURGOGNE',
  BRETAGNE: 'FILTERS_TERRITORIES_BRETAGNE',
  CENTRE_VAL_DE_LOIRE: 'FILTERS_TERRITORIES_CENTRE_VAL_DE_LOIRE',
  CORSE: 'FILTERS_TERRITORIES_CORSE',
  DOM: 'FILTERS_TERRITORIES_DOM',
  GRAND_EST: 'FILTERS_TERRITORIES_GRAND_EST',
  HAUTS_DE_FRANCE: 'FILTERS_TERRITORIES_HAUTS_DE_FRANCE',
  ILE_DE_FRANCE: 'FILTERS_TERRITORIES_ILE_DE_FRANCE',
  NOUVELLE_AQUITAINE: 'FILTERS_TERRITORIES_NOUVELLE_AQUITAINE',
  NORMANDIE: 'FILTERS_TERRITORIES_NORMANDIE',
  OCCITANIE: 'FILTERS_TERRITORIES_OCCITANIE',
  PAYS_DE_LA_LOIRE: 'FILTERS_TERRITORIES_PAYS_DE_LA_LOIRE',
  PACA: 'FILTERS_TERRITORIES_PACA',
  AFRIQUE: 'FILTERS_TERRITORIES_AFRIQUE',
  AMERIQUE: 'FILTERS_TERRITORIES_AMERIQUE',
  ASIE: 'FILTERS_TERRITORIES_ASIE',
  EUROPE: 'FILTERS_TERRITORIES_EUROPE',
  OCEANIE: 'FILTERS_TERRITORIES_OCEANIE',
  NATIONAL: 'FILTERS_TERRITORIES_NATIONAL',
  INTERNATIONAL: 'FILTERS_TERRITORIES_INTERNATIONAL',
};
